import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Masquer le splash screen dès que React a rendu
if (typeof window.__hideSplash === 'function') {
  // Attendre le prochain frame pour s'assurer que le rendu est terminé
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      window.__hideSplash();
    });
  });
}

// Enregistrement du service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(() => console.log('SW registered'))
      .catch((error) => console.log('SW registration failed', error));
  });
}